export const requestHandler = (request: any) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    const parsedToken = JSON.parse(token);
    request.headers.Authorization = `Bearer ${parsedToken}`;
  }
  return request;
};

export const successHandler = (response: any) => {
  return {
    ...response,
    data: response.data,
  };
};

export const errorHandler = (error: any) => {
  const { status } = error.response;
  if (status === 401) {
  }
  return Promise.reject(error);
};
